import { ManualPayment001 } from './001/ManualPayment001';
import { ManualPayment002 } from './002/ManualPayment002';
import { ManualPayment003 } from './003/ManualPayment003';
import { ManualPayment004 } from './004/ManualPayment004';
import { ManualPayment005 } from './005/ManualPayment005';
import { ManualPayment006 } from './006/ManualPayment006';
import { ManualPayment007 } from './007/ManualPayment007';
import { ManualPayment008 } from './008/ManualPayment008';
import { ManualPayment009 } from './009/ManualPayment009';
import { ManualPayment010 } from './010/ManualPayment010';

interface Props {
  id?: string;
}
export const ManualPayment: React.FC<Props> = ({ id }) => {
  const payment = () => {
    switch (id) {
      case 'manual-001':
        return <ManualPayment001></ManualPayment001>;
        break;
      case 'manual-002':
        return <ManualPayment002></ManualPayment002>;
        break;
      case 'manual-003':
        return <ManualPayment003></ManualPayment003>;
        break;
      case 'manual-004':
        return <ManualPayment004></ManualPayment004>;
        break;
      case 'manual-005':
        return <ManualPayment005></ManualPayment005>;
        break;
      case 'manual-006':
        return <ManualPayment006></ManualPayment006>;
        break;
      case 'manual-007':
        return <ManualPayment007></ManualPayment007>;
        break;
      case 'manual-008':
        return <ManualPayment008></ManualPayment008>;
        break;
      case 'manual-009':
        return <ManualPayment009></ManualPayment009>;
        break;
      case 'manual-010':
        return <ManualPayment010></ManualPayment010>;
        break;
      default:
        break;
    }
  };
  return <>{payment()}</>;
};
